import styled from "styled-components";

export const CollabCard = styled.article`
  width: 90vh;
  max-width: 280px;
  height: 120px;
  padding: 0.5rem;
  background-color: var(--secondary-color);
  border-radius: 5px;
  border-bottom-right-radius: 50px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-content: center;
  align-items: center;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;

  .Infos {
    display: flex;
    justify-content: center;
    flex-direction: column;

    h2 {
      margin-bottom: 10px;
    }
  }

  @media (min-width: 500px) {
    max-width: 400px;
    font-size: 1.2rem;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 18%;
`;

export const CollabData = styled.div`
  display: flex;
  color: var(--primary-color);
  font-size: 80%;
  width: 75%;
  height: 100%;
`;
